module.exports = __webpack_public_path__ + "static/img/1.a985fb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/1.png
// module id = 0Phj
// module chunks = 0